import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import Amplitude from "amplitudejs";
import img from "./../../assets/images/selena2.jpg";
import "./style.scss";
import PlayButton from "./PlayButton/playButton";
import {
  bindElements,
  getPlayerState,
  addPlaylist,
} from "../../utils/amplitude-util";
import {
  Fullscreen,
  PlaylistAdd,
  VolumeDown,
  VolumeUp,
  Repeat,
} from "@mui/icons-material";
import ShuffleIcon from "@mui/icons-material/Shuffle";
import NextIcon from "@mui/icons-material/SkipNext";
import SkipPreviousIcon from "@mui/icons-material/SkipPrevious";
import { Box, Stack, Slider } from "@mui/material";
import SongSlider from "./SongSlider/SongSlider";
import VolumeSlider from "./VolumeSlider/VolumeSlider";
import useResize from "../../hooks/resize";
import styled from "styled-components";

const PlayerContainer = styled.div.attrs({ class: "audio-player" })`
  display: flex;
  align-items: stretch;
  @media only screen and (max-width: 600px) {
    flex-direction: column;
  }
`;
const SongMetadata = styled.div`
  display: flex;
  flex: 3;
  align-self: stretch;
  @media only screen and (max-width: 600px) {
    display: none;
  }
`;
const SongControls = styled.div`
    flex:6;
    padding-left:5px;
    padding-right:5px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center,
    justify-content: center;
    @media only screen and (max-width: 600px) {
    width:100%;
    height:50%;
  }
`;
const SongOptions = styled.div`
  flex: 3;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  align-self: stretch;
  @media only screen and (max-width: 600px) {
    flex: 12;
    height: 50%;
  }
`;
const MusicPlayer = React.memo(function MusicPlayer({ playLists }) {
  const device = useResize();
  useEffect(() => {
    if (playLists !== undefined) {
      Object.keys(playLists).forEach((playlistKey) => {
        console.log("playlists", playlistKey);
        addPlaylist(
          playlistKey,
          { name: "erfan", title: "title", author: "author" },
          playLists[playlistKey]["songs"]
        );
      });
    }
  }, [playLists]);
  return (
    <PlayerContainer>
      <div className="blur"></div>
      <SongMetadata>
        <div
          className="music-detail"
          style={{ display: "flex", height: "100%" }}>
          <img
            style={{ width: 50, height: 50, borderRadius: 4 }}
            data-amplitude-song-info="cover_art_url"
            class="album-art"
          />
          <div
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              marginLeft: 8,
              marginTop: 8,
            }}>
            <span>Music name</span>
            <span>Music subtitle</span>
          </div>
        </div>
      </SongMetadata>
      <SongControls>
        <div
          className="controls"
          style={{
            display: "flex",
            flexFlow: "row",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
            margin: "0 auto",
          }}>
          <span class="amplitude-shuffle fa fa-shuffle">
            <ShuffleIcon />
          </span>
          <span className="amplitude-prev">
            <SkipPreviousIcon />
          </span>
          <span className="amplitude-play-pause">
            <PlayButton playingFn={getPlayerState} />
          </span>
          <span className="amplitude-next">
            <NextIcon />
          </span>
          <span className="amplitude-repeat">
            <Repeat color="white" />
          </span>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}>
          <span
            class="amplitude-current-time"
            style={{ color: "white", marginRight: 22, marginBottom: 4 }}>
            00:00
          </span>
          <SongSlider style={{ width: "100%" }} />
          <span
            class="amplitude-duration-time"
            style={{ color: "white", marginLeft: 22, marginBottom: 4 }}>
            00:00
          </span>
        </div>
      </SongControls>
      <SongOptions>
        <PlaylistAdd style={{ marginBottom: 8 }} color="white" />
        <VolumeSlider />
        <Fullscreen style={{ marginBottom: 8, marginRight: 8 }} color="white" />
      </SongOptions>
    </PlayerContainer>
  );
});
const mapStateToProps = (state, ownProps) => {
  return {
    playLists: state.playLists,
  };
};
export default connect(mapStateToProps, null)(MusicPlayer);
